import { withNamespaces } from '@/i18n/route-namespaces'

export const membersRoutes = {
  path: 'members',
  lazy: withNamespaces(['members'], async () => {
    const { BotMembersContainer } = await import('@/pages/bot/members')

    return { Component: BotMembersContainer }
  }),
  children: [
    {
      index: true,
      lazy: withNamespaces(['bots', 'companies', 'members'], async () => {
        const { BotMembersList } = await import('@/pages/bot/members/list')

        return { Component: BotMembersList }
      }),
    },
  ],
}
